const DarkConfluenceBackground = () => {
    return (
        <svg
            viewBox="0 1 1729 1118"
            fill="none"
            style={{
                minWidth: "100%",
                minHeight: "100%",
                position: "absolute"
            }}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_6402_38719)">
                <rect
                    width="1728"
                    height="1117"
                    transform="translate(0.109375 0.867188)"
                    fill="#1D2125"
                />
                <rect
                    width="1728"
                    height="1117"
                    transform="translate(0.109375 0.867188)"
                    fill="#1D2125"
                />
                <g clipPath="url(#clip1_6402_38719)">
                    <rect
                        width="1488"
                        height="1059"
                        transform="translate(240.109 58.8672)"
                        fill="#1D2125"
                    />
                    <g clipPath="url(#clip2_6402_38719)">
                        <g clipPath="url(#clip3_6402_38719)">
                            <rect
                                width="24"
                                height="24"
                                transform="translate(1460.11 90.8672)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M1464.13 110.097C1464.1 110.259 1464.1 110.427 1464.15 110.585C1464.2 110.744 1464.29 110.888 1464.4 111.005C1464.52 111.121 1464.66 111.208 1464.82 111.255C1464.98 111.303 1465.15 111.31 1465.31 111.277L1469.12 110.497L1464.91 106.287L1464.13 110.097ZM1470.05 107.477L1467.93 105.357L1476.42 96.8672H1476.42L1478.54 98.9882L1470.05 107.478L1470.05 107.477ZM1479.95 97.5742L1477.83 95.4522C1477.65 95.2663 1477.43 95.1189 1477.18 95.0185C1476.94 94.9181 1476.68 94.8667 1476.42 94.8672C1475.91 94.8672 1475.39 95.0622 1475 95.4522L1465.25 105.21L1470.2 110.16L1479.95 100.402C1480.33 100.027 1480.54 99.5185 1480.54 98.9882C1480.54 98.4579 1480.33 97.9492 1479.95 97.5742H1479.95Z"
                                fill="#738496"
                            />
                            <rect
                                width="24"
                                height="24"
                                transform="translate(1492.11 90.8672)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M1497.11 102.38C1497.11 99.3422 1500.25 96.8702 1504.11 96.8702C1507.97 96.8702 1511.11 99.3422 1511.11 102.38C1511.11 105.419 1507.97 107.89 1504.11 107.89C1500.25 107.89 1497.11 105.419 1497.11 102.38ZM1511.95 110.151V110.149C1511.95 110.149 1510.38 107.889 1511.18 107.033L1511.14 107.053C1512.37 105.769 1513.11 104.146 1513.11 102.38C1513.11 98.2382 1509.07 94.8672 1504.11 94.8672C1499.15 94.8672 1495.11 98.2372 1495.11 102.38C1495.11 106.523 1499.15 109.894 1504.11 109.894C1505.53 109.894 1506.87 109.609 1508.07 109.118C1509.07 110.14 1510.35 110.69 1511.31 110.837L1511.31 110.834C1511.36 110.854 1511.42 110.865 1511.47 110.867C1511.56 110.867 1511.64 110.846 1511.72 110.806C1511.79 110.766 1511.85 110.707 1511.9 110.636C1511.95 110.566 1511.98 110.484 1511.99 110.399C1511.99 110.315 1511.98 110.229 1511.95 110.151Z"
                                fill="#738496"
                            />
                            <path
                                d="M1508.11 99.8672H1500.11C1499.56 99.8672 1499.11 100.315 1499.11 100.867C1499.11 101.419 1499.56 101.867 1500.11 101.867H1508.11C1508.66 101.867 1509.11 101.419 1509.11 100.867C1509.11 100.315 1508.66 99.8672 1508.11 99.8672Z"
                                fill="#738496"
                            />
                            <path
                                d="M1503.11 102.867H1500.11C1499.56 102.867 1499.11 103.315 1499.11 103.867C1499.11 104.419 1499.56 104.867 1500.11 104.867H1503.11C1503.66 104.867 1504.11 104.419 1504.11 103.867C1504.11 103.315 1503.66 102.867 1503.11 102.867Z"
                                fill="#738496"
                            />
                            <rect
                                width="24"
                                height="24"
                                transform="translate(1524.11 90.8672)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <path
                                d="M1536.11 107.24L1540.09 109.433L1539.33 104.778L1542.6 101.431L1538.08 100.741L1536.11 96.5542L1534.14 100.743L1529.61 101.432L1532.89 104.777L1532.13 109.432L1536.11 107.24ZM1536.11 109.523L1533.09 111.185C1532.76 111.366 1532.39 111.451 1532.02 111.43C1531.64 111.41 1531.28 111.284 1530.97 111.067C1530.67 110.851 1530.43 110.553 1530.28 110.207C1530.14 109.86 1530.09 109.481 1530.15 109.11L1530.75 105.454L1528.18 102.83C1527.92 102.567 1527.74 102.238 1527.66 101.879C1527.58 101.52 1527.6 101.146 1527.71 100.796C1527.83 100.447 1528.04 100.137 1528.32 99.9C1528.61 99.663 1528.95 99.5084 1529.31 99.4532L1532.78 98.9252L1534.3 95.7012C1534.46 95.3581 1534.72 95.0682 1535.04 94.8651C1535.36 94.662 1535.73 94.5541 1536.11 94.5541C1536.49 94.5541 1536.86 94.662 1537.18 94.8651C1537.5 95.0682 1537.76 95.3581 1537.92 95.7012L1539.44 98.9252L1542.91 99.4532C1543.27 99.5087 1543.61 99.6635 1543.89 99.9007C1544.18 100.138 1544.39 100.448 1544.5 100.797C1544.62 101.146 1544.64 101.521 1544.55 101.88C1544.47 102.238 1544.29 102.567 1544.03 102.83L1541.46 105.454L1542.06 109.11C1542.12 109.481 1542.08 109.861 1541.93 110.207C1541.79 110.553 1541.55 110.852 1541.24 111.068C1540.94 111.285 1540.58 111.41 1540.2 111.431C1539.83 111.452 1539.45 111.367 1539.12 111.185L1536.11 109.523Z"
                                fill="#738496"
                            />
                            <rect
                                width="24"
                                height="24"
                                transform="translate(1556.11 90.8672)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M1568.11 108.867C1563.57 108.867 1560.11 104.607 1560.11 102.867C1560.11 100.866 1563.57 96.8672 1568.11 96.8672C1572.49 96.8672 1576.11 100.84 1576.11 102.867C1576.11 104.607 1572.65 108.867 1568.11 108.867H1568.11ZM1568.11 94.8672C1562.59 94.8672 1558.11 99.7082 1558.11 102.867C1558.11 105.953 1562.69 110.867 1568.11 110.867C1573.53 110.867 1578.11 105.953 1578.11 102.867C1578.11 99.7082 1573.63 94.8672 1568.11 94.8672"
                                fill="#738496"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M1568.09 104.851C1566.98 104.851 1566.09 103.954 1566.09 102.851C1566.09 101.748 1566.98 100.851 1568.09 100.851C1569.19 100.851 1570.09 101.748 1570.09 102.851C1570.09 103.954 1569.19 104.851 1568.09 104.851ZM1568.09 98.8512C1565.88 98.8512 1564.09 100.645 1564.09 102.851C1564.09 105.057 1565.88 106.851 1568.09 106.851C1570.29 106.851 1572.09 105.057 1572.09 102.851C1572.09 100.645 1570.29 98.8512 1568.09 98.8512Z"
                                fill="#738496"
                            />
                        </g>
                        <rect
                            x="1590.11"
                            y="86.8672"
                            width="60"
                            height="32"
                            rx="3"
                            fill="#A1BDD9"
                            fillOpacity="0.08"
                        />
                        <rect
                            x="1598.11"
                            y="99.8672"
                            width="44"
                            height="6"
                            rx="3"
                            fill="#454F59"
                        />
                        <rect
                            width="24"
                            height="24"
                            transform="translate(1660.11 90.8672)"
                            fill="white"
                            fillOpacity="0.01"
                        />
                        <path
                            d="M1665.11 104.867C1666.21 104.867 1667.11 103.972 1667.11 102.867C1667.11 101.763 1666.21 100.867 1665.11 100.867C1664 100.867 1663.11 101.763 1663.11 102.867C1663.11 103.972 1664 104.867 1665.11 104.867Z"
                            fill="#738496"
                        />
                        <path
                            d="M1672.11 104.867C1673.21 104.867 1674.11 103.972 1674.11 102.867C1674.11 101.763 1673.21 100.867 1672.11 100.867C1671 100.867 1670.11 101.763 1670.11 102.867C1670.11 103.972 1671 104.867 1672.11 104.867Z"
                            fill="#738496"
                        />
                        <path
                            d="M1679.11 104.867C1680.21 104.867 1681.11 103.972 1681.11 102.867C1681.11 101.763 1680.21 100.867 1679.11 100.867C1678 100.867 1677.11 101.763 1677.11 102.867C1677.11 103.972 1678 104.867 1679.11 104.867Z"
                            fill="#738496"
                        />
                    </g>
                    <rect
                        x="604.109"
                        y="146.867"
                        width="503"
                        height="20"
                        rx="3"
                        fill="#454F59"
                    />
                    <g clipPath="url(#clip4_6402_38719)">
                        <rect
                            x="648.109"
                            y="206.867"
                            width="192"
                            height="6"
                            rx="3"
                            fill="#454F59"
                        />
                    </g>
                    <g clipPath="url(#clip5_6402_38719)">
                        <rect
                            x="648.109"
                            y="194.867"
                            width="119"
                            height="6"
                            rx="3"
                            fill="#454F59"
                        />
                    </g>
                    <g clipPath="url(#clip6_6402_38719)">
                        <path
                            d="M636.109 206.867C636.109 198.031 628.946 190.867 620.109 190.867C611.273 190.867 604.109 198.031 604.109 206.867C604.109 215.704 611.273 222.867 620.109 222.867C628.946 222.867 636.109 215.704 636.109 206.867Z"
                            fill="#FFC400"
                        />
                        <path
                            d="M620.13 218.415C622.101 218.408 623.622 217.599 624.713 216.303H624.748C624.434 216.096 624.17 215.904 624.172 215.896C624.047 215.804 623.927 214.452 623.845 213.132C622.762 214.017 621.615 214.376 621.006 214.844C620.535 215.205 618.725 215.054 618.259 214.614C617.652 214.043 617.048 213.485 616.508 212.906C616.454 214.312 616.354 215.848 616.244 215.955C616.244 215.958 615.947 216.157 615.602 216.365C616.69 217.624 618.192 218.408 620.13 218.415Z"
                            fill="url(#paint0_linear_6402_38719)"
                        />
                        <path
                            d="M624.813 216.303H624.713C623.622 217.599 622.101 218.408 620.13 218.415C618.192 218.408 616.69 217.624 615.602 216.365C615.584 216.344 615.566 216.324 615.548 216.303H615.448C615.448 216.303 612.501 217.716 609.908 219.114C612.678 221.408 616.231 222.788 620.107 222.788C623.991 222.788 627.552 221.403 630.324 219.101C627.739 217.711 624.81 216.306 624.81 216.306L624.813 216.303Z"
                            fill="#FF991F"
                        />
                        <path
                            d="M626.509 206.606C626.458 207.233 626.348 207.978 626.202 208.695C626.223 208.692 626.243 208.685 626.264 208.687C626.41 208.7 626.517 208.826 626.504 208.972C626.492 209.117 626.366 209.225 626.22 209.212C626.174 209.21 626.133 209.189 626.097 209.166C626.067 209.299 626.033 209.43 626 209.558C626.389 209.458 626.645 209.123 626.689 208.529C626.748 207.697 627.229 206.092 626.868 205.526C626.778 205.892 626.655 206.181 626.522 206.404C626.517 206.47 626.515 206.537 626.509 206.604V206.606Z"
                            fill="#F7DAC6"
                        />
                        <path
                            d="M614.37 208.347C614.224 208.334 614.116 208.209 614.129 208.063C614.142 207.917 614.267 207.809 614.413 207.822C614.441 207.822 614.467 207.835 614.493 207.845C614.429 207.169 614.382 206.465 614.393 205.938C614.249 205.751 614.096 205.477 613.993 205.088C613.868 205.807 613.975 206.885 613.919 207.505C613.858 208.17 614.116 208.557 614.577 208.68C614.564 208.557 614.549 208.431 614.536 208.301C614.487 208.334 614.431 208.355 614.37 208.349V208.347Z"
                            fill="#F7DAC6"
                        />
                        <path
                            d="M626.504 208.972C626.517 208.826 626.407 208.7 626.263 208.687C626.243 208.687 626.222 208.692 626.202 208.695C626.169 208.854 626.135 209.012 626.1 209.166C626.135 209.189 626.176 209.21 626.222 209.212C626.368 209.225 626.494 209.115 626.507 208.972H626.504Z"
                            fill="#253858"
                        />
                        <path
                            d="M614.13 208.063C614.117 208.209 614.227 208.334 614.371 208.347C614.432 208.352 614.488 208.331 614.537 208.298C614.522 208.15 614.506 207.996 614.493 207.843C614.468 207.832 614.442 207.822 614.414 207.819C614.268 207.807 614.143 207.917 614.13 208.06V208.063Z"
                            fill="#253858"
                        />
                        <path
                            d="M618.258 214.614C618.724 215.054 620.534 215.205 621.005 214.844C621.614 214.376 622.764 214.017 623.844 213.132C624.461 212.625 625.058 211.949 625.521 210.979C625.695 210.615 625.859 210.116 626.002 209.56C626.036 209.432 626.066 209.302 626.1 209.169C626.135 209.012 626.171 208.856 626.202 208.698C626.35 207.981 626.458 207.236 626.509 206.609C626.514 206.542 626.517 206.476 626.522 206.409C626.156 207.023 625.723 207.167 625.723 207.167C625.723 207.167 625.808 206.563 625.785 205.866C625.639 201.537 623.299 199.988 621.847 199.558C620.931 199.991 619.525 201.061 619.538 203.578C619.538 203.578 617.012 204.028 615.537 202.93C615.281 203.519 615.066 204.202 614.91 204.991C614.777 205.674 614.761 206.284 614.761 206.284C614.761 206.284 614.585 206.189 614.39 205.938C614.38 206.465 614.426 207.167 614.49 207.845C614.505 207.999 614.518 208.152 614.533 208.301C614.546 208.431 614.562 208.557 614.574 208.68C614.661 209.46 614.746 210.06 614.746 210.06C615.033 211.135 615.693 212.043 616.502 212.906C617.042 213.485 617.649 214.043 618.253 214.614H618.258Z"
                            fill="#FFE5D4"
                        />
                        <path
                            d="M621.512 196.148L620.683 196.082C618.555 195.967 614.464 196.625 613.896 203.688C613.85 204.269 613.901 204.724 613.996 205.085C614.098 205.475 614.249 205.748 614.395 205.935C614.59 206.186 614.766 206.281 614.766 206.281C614.766 206.281 614.779 205.669 614.915 204.988C615.071 204.2 615.286 203.516 615.542 202.927C615.371 202.799 615.212 202.648 615.074 202.474C614.933 202.298 614.815 202.098 614.72 201.868C614.72 201.868 615.678 196.033 621.945 197.006C621.97 197.006 622.111 197.615 622.242 198.209C622.367 198.772 622.482 199.318 622.482 199.318C622.347 199.354 622.119 199.43 621.853 199.556C623.302 199.986 625.644 201.535 625.79 205.864C625.813 206.56 625.728 207.164 625.728 207.164C625.728 207.164 626.164 207.018 626.527 206.406C626.66 206.181 626.783 205.892 626.873 205.528C626.929 205.298 626.975 205.042 626.998 204.745C627.566 197.679 623.634 196.376 621.515 196.151L621.512 196.148Z"
                            fill="url(#paint1_linear_6402_38719)"
                        />
                        <path
                            d="M622.24 198.209C622.109 197.618 621.969 197.009 621.943 197.006C615.676 196.033 614.719 201.868 614.719 201.868C614.811 202.098 614.931 202.298 615.072 202.474C615.21 202.648 615.369 202.799 615.541 202.927C617.015 204.028 619.542 203.575 619.542 203.575C619.529 201.059 620.934 199.988 621.851 199.556C622.117 199.43 622.345 199.356 622.481 199.318C622.481 199.318 622.365 198.77 622.24 198.209Z"
                            fill="#0065FF"
                        />
                    </g>
                    <rect
                        x="604.109"
                        y="246.867"
                        width="760"
                        height="86"
                        rx="5"
                        fill="#092957"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M632.109 284.867C626.586 284.867 622.109 280.39 622.109 274.867C622.109 269.344 626.586 264.867 632.109 264.867C637.632 264.867 642.109 269.344 642.109 274.867C642.109 280.39 637.632 284.867 632.109 284.867ZM633.109 270.867C633.109 271.419 632.662 271.867 632.109 271.867C631.557 271.867 631.109 271.419 631.109 270.867C631.109 270.315 631.557 269.867 632.109 269.867C632.662 269.867 633.109 270.315 633.109 270.867ZM632.109 272.867C632.662 272.867 633.109 273.315 633.109 273.867V278.867C633.109 279.419 632.662 279.867 632.109 279.867C631.557 279.867 631.109 279.419 631.109 278.867V273.867C631.109 273.315 631.557 272.867 632.109 272.867Z"
                        fill="#388BFF"
                    />
                    <rect
                        x="670.109"
                        y="272.867"
                        width="659"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="670.109"
                        y="294.867"
                        width="325"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="364.867"
                        width="117"
                        height="20"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="400.867"
                        width="98.5"
                        height="20"
                        rx="10"
                        fill="#092957"
                    />
                    <path
                        d="M616.85 417.467C613.322 417.467 611.087 415.252 611.087 411.766V411.752C611.087 408.375 613.384 406.058 616.733 406.058C619.967 406.058 622.216 408.122 622.216 411.082V411.096C622.216 413.317 621.218 414.732 619.646 414.732C618.859 414.732 618.258 414.288 618.148 413.625L618.142 413.584H618.032C617.738 414.281 617.123 414.671 616.323 414.671C614.901 414.671 613.944 413.502 613.944 411.772V411.759C613.944 410.104 614.922 408.942 616.323 408.942C617.041 408.942 617.656 409.312 617.923 409.906H618.032V409.072H619.064V413.085C619.064 413.563 619.345 413.844 619.837 413.844C620.698 413.844 621.252 412.757 621.252 411.082V411.068C621.252 408.607 619.379 406.919 616.645 406.919C613.972 406.919 612.051 408.956 612.051 411.793V411.807C612.051 414.719 613.938 416.599 616.863 416.599C617.8 416.599 618.723 416.469 619.153 416.271V417.132C618.538 417.344 617.711 417.467 616.85 417.467ZM616.48 413.707C617.417 413.707 618.019 412.962 618.019 411.8V411.786C618.019 410.624 617.424 409.886 616.494 409.886C615.578 409.886 615.038 410.597 615.038 411.786V411.8C615.038 412.982 615.585 413.707 616.48 413.707Z"
                        fill="#8696A7"
                    />
                    <rect
                        x="625.609"
                        y="407.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="710.609"
                        y="400.867"
                        width="98.5"
                        height="20"
                        rx="10"
                        fill="#A1BDD9"
                        fillOpacity="0.08"
                    />
                    <path
                        d="M723.35 417.467C719.822 417.467 717.587 415.252 717.587 411.766V411.752C717.587 408.375 719.884 406.058 723.233 406.058C726.467 406.058 728.716 408.122 728.716 411.082V411.096C728.716 413.317 727.718 414.732 726.146 414.732C725.359 414.732 724.758 414.288 724.648 413.625L724.642 413.584H724.532C724.238 414.281 723.623 414.671 722.823 414.671C721.401 414.671 720.444 413.502 720.444 411.772V411.759C720.444 410.104 721.422 408.942 722.823 408.942C723.541 408.942 724.156 409.312 724.423 409.906H724.532V409.072H725.564V413.085C725.564 413.563 725.845 413.844 726.337 413.844C727.198 413.844 727.752 412.757 727.752 411.082V411.068C727.752 408.607 725.879 406.919 723.145 406.919C720.472 406.919 718.551 408.956 718.551 411.793V411.807C718.551 414.719 720.438 416.599 723.363 416.599C724.3 416.599 725.223 416.469 725.653 416.271V417.132C725.038 417.344 724.211 417.467 723.35 417.467ZM722.98 413.707C723.917 413.707 724.519 412.962 724.519 411.8V411.786C724.519 410.624 723.924 409.886 722.994 409.886C722.078 409.886 721.538 410.597 721.538 411.786V411.8C721.538 412.982 722.085 413.707 722.98 413.707Z"
                        fill="#8696A7"
                    />
                    <rect
                        x="732.109"
                        y="407.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="817.109"
                        y="400.867"
                        width="98.5"
                        height="20"
                        rx="10"
                        fill="#A1BDD9"
                        fillOpacity="0.08"
                    />
                    <path
                        d="M829.85 417.467C826.322 417.467 824.087 415.252 824.087 411.766V411.752C824.087 408.375 826.384 406.058 829.733 406.058C832.967 406.058 835.216 408.122 835.216 411.082V411.096C835.216 413.317 834.218 414.732 832.646 414.732C831.859 414.732 831.258 414.288 831.148 413.625L831.142 413.584H831.032C830.738 414.281 830.123 414.671 829.323 414.671C827.901 414.671 826.944 413.502 826.944 411.772V411.759C826.944 410.104 827.922 408.942 829.323 408.942C830.041 408.942 830.656 409.312 830.923 409.906H831.032V409.072H832.064V413.085C832.064 413.563 832.345 413.844 832.837 413.844C833.698 413.844 834.252 412.757 834.252 411.082V411.068C834.252 408.607 832.379 406.919 829.645 406.919C826.972 406.919 825.051 408.956 825.051 411.793V411.807C825.051 414.719 826.938 416.599 829.863 416.599C830.8 416.599 831.723 416.469 832.153 416.271V417.132C831.538 417.344 830.711 417.467 829.85 417.467ZM829.48 413.707C830.417 413.707 831.019 412.962 831.019 411.8V411.786C831.019 410.624 830.424 409.886 829.494 409.886C828.578 409.886 828.038 410.597 828.038 411.786V411.8C828.038 412.982 828.585 413.707 829.48 413.707Z"
                        fill="#8696A7"
                    />
                    <rect
                        x="838.609"
                        y="407.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="452.867"
                        width="290"
                        height="20"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="488.867"
                        width="730"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="516.867"
                        width="730"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="544.867"
                        width="343"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="620.109"
                        y="582.867"
                        width="12"
                        height="12"
                        rx="2"
                        fill="#1D2125"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M622.109 582.867H630.109C631.214 582.867 632.109 583.763 632.109 584.867V592.867C632.109 593.972 631.214 594.867 630.109 594.867H622.109C621.005 594.867 620.109 593.972 620.109 592.867V584.867C620.109 583.763 621.005 582.867 622.109 582.867ZM623.492 587.936C623.614 587.989 623.724 588.065 623.816 588.16L625.109 589.453L628.402 586.16C628.495 586.065 628.605 585.989 628.727 585.936C628.849 585.884 628.98 585.856 629.113 585.855C629.246 585.854 629.377 585.879 629.5 585.929C629.623 585.98 629.735 586.054 629.829 586.148C629.923 586.242 629.997 586.353 630.047 586.476C630.097 586.599 630.123 586.731 630.122 586.864C630.12 586.996 630.093 587.128 630.04 587.25C629.988 587.372 629.912 587.482 629.816 587.574L625.816 591.574C625.629 591.762 625.375 591.867 625.109 591.867C624.844 591.867 624.59 591.762 624.402 591.574L622.402 589.574C622.307 589.482 622.231 589.372 622.178 589.25C622.126 589.128 622.098 588.996 622.097 588.864C622.096 588.731 622.121 588.599 622.172 588.476C622.222 588.353 622.296 588.242 622.39 588.148C622.484 588.054 622.596 587.98 622.718 587.929C622.841 587.879 622.973 587.854 623.106 587.855C623.239 587.856 623.37 587.884 623.492 587.936Z"
                        fill="#388BFF"
                    />
                    <rect
                        x="640.109"
                        y="585.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="620.109"
                        y="614.867"
                        width="12"
                        height="12"
                        rx="2"
                        fill="#1D2125"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M622.109 614.867H630.109C631.214 614.867 632.109 615.763 632.109 616.867V624.867C632.109 625.972 631.214 626.867 630.109 626.867H622.109C621.005 626.867 620.109 625.972 620.109 624.867V616.867C620.109 615.763 621.005 614.867 622.109 614.867ZM623.492 619.936C623.614 619.989 623.724 620.065 623.816 620.16L625.109 621.453L628.402 618.16C628.495 618.065 628.605 617.989 628.727 617.936C628.849 617.884 628.98 617.856 629.113 617.855C629.246 617.854 629.377 617.879 629.5 617.929C629.623 617.98 629.735 618.054 629.829 618.148C629.923 618.242 629.997 618.353 630.047 618.476C630.097 618.599 630.123 618.731 630.122 618.864C630.12 618.996 630.093 619.128 630.04 619.25C629.988 619.372 629.912 619.482 629.816 619.574L625.816 623.574C625.629 623.762 625.375 623.867 625.109 623.867C624.844 623.867 624.59 623.762 624.402 623.574L622.402 621.574C622.307 621.482 622.231 621.372 622.178 621.25C622.126 621.128 622.098 620.996 622.097 620.864C622.096 620.731 622.121 620.599 622.172 620.476C622.222 620.353 622.296 620.242 622.39 620.148C622.484 620.054 622.596 619.98 622.718 619.929C622.841 619.879 622.973 619.854 623.106 619.855C623.239 619.856 623.37 619.884 623.492 619.936Z"
                        fill="#388BFF"
                    />
                    <rect
                        x="640.109"
                        y="617.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="621.109"
                        y="647.867"
                        width="10"
                        height="10"
                        rx="1"
                        stroke="#8696A7"
                        strokeWidth="2"
                    />
                    <rect
                        x="640.109"
                        y="649.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="621.109"
                        y="679.867"
                        width="10"
                        height="10"
                        rx="1"
                        stroke="#8696A7"
                        strokeWidth="2"
                    />
                    <rect
                        x="640.109"
                        y="681.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="621.109"
                        y="711.867"
                        width="10"
                        height="10"
                        rx="1"
                        stroke="#8696A7"
                        strokeWidth="2"
                    />
                    <rect
                        x="640.109"
                        y="713.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="748.867"
                        width="730"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="776.867"
                        width="730"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="804.867"
                        width="343"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="880.867"
                        width="290"
                        height="20"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="916.867"
                        width="730"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="944.867"
                        width="730"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="972.867"
                        width="730"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="1000.87"
                        width="730"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="604.109"
                        y="1028.87"
                        width="343"
                        height="12"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="272.109"
                        y="99.8672"
                        width="100"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="385.109"
                        y="99.8672"
                        width="54"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <path
                        d="M380.811 97.5312L377.796 110.342H376.401L379.416 97.5312H380.811Z"
                        fill="#9FADBC"
                    />
                </g>
                <rect
                    width="240"
                    height="1059"
                    transform="translate(0.109375 58.8672)"
                    fill="#161A1D"
                />
                <g clipPath="url(#clip7_6402_38719)">
                    <rect
                        x="22.1094"
                        y="142.867"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="66.1094"
                        y="155.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="22.1094"
                        y="186.867"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="66.1094"
                        y="199.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="22.1094"
                        y="230.867"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="66.1094"
                        y="243.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="22.1094"
                        y="274.867"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="66.1094"
                        y="287.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="22.1094"
                        y="344.867"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="66.1094"
                        y="357.867"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <rect
                        x="16.1094"
                        y="384.867"
                        width="208"
                        height="40"
                        rx="3"
                        fill="#2C333A"
                    />
                    <circle cx="52.1094" cy="404.867" r="2" fill="#454F59" />
                    <rect
                        x="72.1094"
                        y="401.867"
                        width="125"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <circle cx="52.1094" cy="448.867" r="2" fill="#454F59" />
                    <rect
                        x="72.1094"
                        y="445.867"
                        width="125"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                    <circle cx="52.1094" cy="492.867" r="2" fill="#454F59" />
                    <rect
                        x="72.1094"
                        y="489.867"
                        width="125"
                        height="6"
                        rx="3"
                        fill="#454F59"
                    />
                </g>
                <rect
                    x="18.1094"
                    y="82.8672"
                    width="40"
                    height="40"
                    rx="3"
                    fill="#092957"
                />
                <rect
                    x="66.1094"
                    y="87.8672"
                    width="97"
                    height="12"
                    rx="3"
                    fill="#454F59"
                />
                <rect
                    x="66.1094"
                    y="111.867"
                    width="141"
                    height="6"
                    rx="3"
                    fill="#454F59"
                />
                <rect
                    width="1727"
                    height="56"
                    transform="translate(0.109375 0.867188)"
                    fill="#1D2125"
                />
                <rect
                    x="0.109375"
                    y="56.8672"
                    width="1727"
                    height="2"
                    fill="#A6C5E2"
                    fillOpacity="0.16"
                />
                <rect
                    width="32"
                    height="32"
                    transform="translate(1671.11 12.8672)"
                    fill="white"
                    fillOpacity="0.01"
                />
                <g clipPath="url(#clip8_6402_38719)">
                    <path
                        d="M1702.04 28.8636C1702.04 20.6171 1695.35 13.932 1687.11 13.932C1678.86 13.932 1672.18 20.6171 1672.18 28.8636C1672.18 37.1101 1678.86 43.7952 1687.11 43.7952C1695.35 43.7952 1702.04 37.1101 1702.04 28.8636Z"
                        fill="#B2D4FF"
                    />
                    <path
                        d="M1693.5 40.5576C1691.9 39.9 1690.85 38.34 1690.85 36.6072C1690.84 35.3688 1691.38 34.1904 1692.32 33.3888C1698.21 28.4448 1694.55 18.8712 1686.96 19.0248C1679.51 19.152 1676.12 28.548 1681.9 33.3888C1682.84 34.1904 1683.38 35.3688 1683.37 36.6072C1683.37 38.34 1682.32 39.9024 1680.72 40.5576C1680.26 40.7496 1679.8 40.9632 1679.35 41.1888C1679.23 41.2536 1679.11 41.328 1678.99 41.3952C1681.33 42.9144 1684.11 43.8024 1687.11 43.8024C1690.11 43.8024 1692.9 42.9144 1695.24 41.3928C1695.03 41.2752 1694.81 41.16 1694.59 41.052C1694.24 40.8696 1693.87 40.7136 1693.51 40.5576H1693.5Z"
                        fill="#2684FF"
                    />
                </g>
                <g clipPath="url(#clip9_6402_38719)">
                    <rect
                        x="1340.11"
                        y="12.8672"
                        width="238"
                        height="32"
                        rx="3"
                        fill="#A1BDD9"
                        fillOpacity="0.08"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1361.11 27.8672C1361.11 30.0763 1359.32 31.8672 1357.11 31.8672C1354.9 31.8672 1353.11 30.0763 1353.11 27.8672C1353.11 25.658 1354.9 23.8672 1357.11 23.8672C1359.32 23.8672 1361.11 25.658 1361.11 27.8672ZM1360.59 32.7579C1359.61 33.4564 1358.41 33.8672 1357.11 33.8672C1353.8 33.8672 1351.11 31.1809 1351.11 27.8672C1351.11 24.5535 1353.8 21.8672 1357.11 21.8672C1360.42 21.8672 1363.11 24.5535 1363.11 27.8672C1363.11 29.163 1362.7 30.3629 1362 31.3437L1364.82 34.1601C1365.21 34.5506 1365.21 35.1838 1364.82 35.5743C1364.43 35.9648 1363.79 35.9648 1363.4 35.5743L1360.59 32.7579Z"
                        fill="#738496"
                    />
                    <g clipPath="url(#clip10_6402_38719)">
                        <rect
                            width="24"
                            height="24"
                            transform="translate(1589.11 16.8672)"
                            fill="white"
                            fillOpacity="0.01"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1595.59 34.5362C1595.78 34.722 1596 34.8694 1596.24 34.9699C1596.49 35.0705 1596.75 35.1223 1597.01 35.1223C1597.27 35.1223 1597.53 35.0705 1597.77 34.9699C1598.02 34.8694 1598.24 34.722 1598.42 34.5362L1595.59 31.7062C1595.41 31.8919 1595.26 32.1125 1595.16 32.3553C1595.06 32.5981 1595.01 32.8584 1595.01 33.1212C1595.01 33.384 1595.06 33.6443 1595.16 33.8871C1595.26 34.1299 1595.41 34.3504 1595.59 34.5362ZM1600.49 22.3452L1599.77 23.0702C1598.98 23.8522 1597.56 24.8832 1596.56 25.3812L1593.54 26.8902C1593.05 27.1382 1592.96 27.6642 1593.36 28.0612L1601.91 36.6172C1602.31 37.0132 1602.83 36.9302 1603.08 36.4292L1604.59 33.4132C1605.09 32.4252 1606.12 30.9932 1606.9 30.2072L1607.63 29.4812C1608.45 28.658 1608.97 27.5756 1609.08 26.4173C1609.2 25.259 1608.91 24.0959 1608.27 23.1252C1608.38 23.039 1608.47 22.9318 1608.53 22.81C1608.59 22.6882 1608.63 22.5546 1608.64 22.4172C1608.66 22.2798 1608.64 22.1417 1608.59 22.0113C1608.55 21.8808 1608.48 21.7608 1608.39 21.6587C1608.29 21.5566 1608.18 21.4745 1608.06 21.4175C1607.93 21.3605 1607.79 21.3298 1607.66 21.3272C1607.52 21.3246 1607.38 21.3502 1607.25 21.4025C1607.13 21.4548 1607.01 21.5326 1606.92 21.6312C1606.89 21.6562 1606.87 21.6802 1606.85 21.7062C1606.02 21.1581 1605.05 20.866 1604.06 20.8662C1603.4 20.8654 1602.74 20.9955 1602.13 21.2492C1601.52 21.5028 1600.96 21.8749 1600.49 22.3442V22.3452Z"
                            fill="#738496"
                        />
                        <rect
                            width="24"
                            height="24"
                            transform="translate(1629.11 16.8672)"
                            fill="white"
                            fillOpacity="0.01"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1651.11 28.8672C1651.11 34.39 1646.63 38.8672 1641.11 38.8672C1635.59 38.8672 1631.11 34.39 1631.11 28.8672C1631.11 23.3443 1635.59 18.8672 1641.11 18.8672C1646.63 18.8672 1651.11 23.3443 1651.11 28.8672ZM1643.94 24.0272C1644.46 24.5466 1644.83 25.201 1645 25.9172C1645.23 26.8752 1645.1 27.8853 1644.63 28.7528C1644.16 29.6203 1643.39 30.2837 1642.46 30.6152C1642.26 30.6882 1642.11 30.8702 1642.11 31.0872V31.8692C1642.11 32.1349 1642.01 32.3898 1641.82 32.5777C1641.63 32.7656 1641.38 32.8712 1641.11 32.8712C1640.85 32.8712 1640.59 32.7656 1640.4 32.5777C1640.21 32.3898 1640.11 32.1349 1640.11 31.8692V29.8552C1640.11 29.5922 1640.22 29.3412 1640.41 29.1565C1640.59 28.9718 1640.85 28.8682 1641.11 28.8682H1641.1C1642.21 28.8682 1643.11 27.9702 1643.11 26.8682C1643.09 26.3446 1642.88 25.8465 1642.5 25.4805C1642.13 25.1145 1641.62 24.9097 1641.1 24.9099C1640.58 24.9102 1640.07 25.1155 1639.7 25.4819C1639.33 25.8482 1639.11 26.3466 1639.1 26.8702C1639.1 27.4212 1638.65 27.8682 1638.1 27.8682C1637.85 27.8667 1637.61 27.7732 1637.43 27.606C1637.25 27.4389 1637.14 27.21 1637.11 26.9642L1637.11 26.8172C1637.13 24.3132 1639.43 22.3812 1642.04 22.9752C1642.76 23.1435 1643.42 23.5077 1643.94 24.0272ZM1642.11 34.8672C1642.11 35.4195 1641.66 35.8672 1641.11 35.8672C1640.56 35.8672 1640.11 35.4195 1640.11 34.8672C1640.11 34.3149 1640.56 33.8672 1641.11 33.8672C1641.66 33.8672 1642.11 34.3149 1642.11 34.8672Z"
                            fill="#738496"
                        />
                    </g>
                </g>
                <g clipPath="url(#clip11_6402_38719)">
                    <g clipPath="url(#clip12_6402_38719)">
                        <path
                            d="M88.3141 35.3586C87.3459 35.9792 85.8128 36.2379 84.199 36.2379C79.0888 36.2379 76.2109 33.2896 76.2109 28.5568C76.2109 24.0051 79.0888 20.8241 84.1721 20.8241C85.6783 20.8241 87.2114 21.1086 88.3141 21.8586V23.8499C87.2114 23.1775 85.9742 22.8155 84.1721 22.8155C80.5143 22.8155 78.3626 25.143 78.3626 28.5827C78.3626 32.0224 80.6219 34.2982 84.3066 34.2982C85.9473 34.2982 87.2114 33.9361 88.341 33.393V35.3586H88.3141Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M89.7934 30.3155C89.7934 26.9017 91.8644 24.4189 95.4146 24.4189C98.938 24.4189 101.009 26.9017 101.009 30.3155C101.009 33.7293 98.938 36.2637 95.4146 36.2637C91.8913 36.2379 89.7934 33.7293 89.7934 30.3155ZM91.7837 30.3155C91.7837 32.4879 92.8864 34.4275 95.4415 34.4275C97.9429 34.4275 99.0456 32.462 99.0456 30.3155C99.0456 28.1689 97.9698 26.2293 95.4415 26.2293C92.8864 26.2293 91.7837 28.143 91.7837 30.3155Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M113.435 36.031H111.391V29.1517C111.391 27.1086 110.53 26.2034 108.594 26.2034C106.711 26.2034 105.393 27.4189 105.393 29.7206V36.0568H103.349V24.6775H105.393V26.5396C106.146 25.1948 107.545 24.4448 109.132 24.4448C111.848 24.4448 113.408 26.2551 113.408 29.3844V36.031H113.435Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M122.176 24.6517V26.462H119.11V36.031H117.12V26.462H115.21V24.6517H117.12V23.4103C117.12 21.2896 118.357 19.8672 120.885 19.8672C121.504 19.8672 121.907 19.9706 122.257 20.0482V21.8586C121.907 21.781 121.45 21.7551 120.966 21.7551C119.702 21.7551 119.083 22.4534 119.083 23.4879V24.6517H122.176Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M127.528 36.0827C125.592 36.0827 124.355 35.2034 124.355 33.1086V19.893H126.399V32.8758C126.399 33.9103 127.098 34.2724 127.986 34.2724C128.201 34.2724 128.335 34.2724 128.577 34.2465V36.0051C128.389 36.0568 128.039 36.0827 127.528 36.0827Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M130.299 24.6517H132.343V31.531C132.343 33.5741 133.203 34.4793 135.14 34.4793C137.023 34.4793 138.341 33.2637 138.341 30.962V24.6517H140.385V36.031H138.341V34.1689C137.587 35.5137 136.189 36.2637 134.602 36.2637C131.886 36.2637 130.326 34.4534 130.326 31.3241V24.6517H130.299Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M149.099 36.2379C144.661 36.2379 142.725 33.781 142.725 30.2896C142.725 26.8499 144.715 24.393 148.319 24.393C151.977 24.393 153.429 26.8241 153.429 30.2896V31.1689H144.796C145.092 33.1086 146.383 34.3499 149.18 34.3499C150.551 34.3499 151.708 34.0913 152.784 33.7293V35.5396C151.789 36.0568 150.282 36.2379 149.099 36.2379ZM144.742 29.5137H151.358C151.251 27.3931 150.256 26.2034 148.211 26.2034C146.06 26.2034 144.957 27.5224 144.742 29.5137Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M165.882 36.031H163.838V29.1517C163.838 27.1086 162.977 26.2034 161.041 26.2034C159.158 26.2034 157.84 27.4189 157.84 29.7206V36.0568H155.796V24.6775H157.84V26.5396C158.593 25.1948 159.992 24.4448 161.579 24.4448C164.295 24.4448 165.855 26.2551 165.855 29.3844V36.031H165.882Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M177.098 35.7206C176.398 36.0827 175.296 36.2379 174.22 36.2379C169.997 36.2379 168.034 33.781 168.034 30.2896C168.034 26.8499 169.997 24.393 174.22 24.393C175.296 24.393 176.103 24.5224 177.044 24.9362V26.7465C176.291 26.4103 175.484 26.2034 174.381 26.2034C171.315 26.2034 170.051 28.0655 170.051 30.2896C170.051 32.5137 171.342 34.3758 174.435 34.3758C175.645 34.3758 176.398 34.2206 177.125 33.962V35.7206H177.098Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M185.059 36.2379C180.621 36.2379 178.684 33.781 178.684 30.2896C178.684 26.8499 180.675 24.393 184.279 24.393C187.937 24.393 189.389 26.8241 189.389 30.2896V31.1689H180.755C181.051 33.1086 182.342 34.3499 185.14 34.3499C186.511 34.3499 187.668 34.0913 188.744 33.7293V35.5396C187.748 36.0568 186.269 36.2379 185.059 36.2379ZM180.729 29.5137H187.345C187.237 27.3931 186.242 26.2034 184.198 26.2034C182.02 26.2034 180.944 27.5224 180.729 29.5137Z"
                            fill="#9FADBC"
                        />
                        <path
                            d="M52.7301 33.2924C52.5687 33.5924 52.3536 33.9197 52.1922 34.1925C52.0308 34.4379 52.1115 34.7652 52.3804 34.9288L55.8769 37.1107C56.1459 37.2743 56.4686 37.1925 56.63 36.9198C56.7645 36.6743 56.9528 36.3743 57.141 36.047C58.5396 33.7288 59.9113 34.0015 62.4395 35.2288L65.9091 36.8925C66.1781 37.0289 66.5008 36.8925 66.6353 36.6198L68.3028 32.8015C68.4104 32.5288 68.3028 32.2015 68.0339 32.0924C67.3077 31.7379 65.8553 31.056 64.5374 30.4015C59.8037 28.1105 55.7962 28.2469 52.7301 33.2924Z"
                            fill="url(#paint2_linear_6402_38719)"
                        />
                        <path
                            d="M68.4113 24.6468C68.5727 24.3468 68.7878 24.0195 68.9492 23.7468C69.1106 23.5014 69.0299 23.1741 68.7609 23.0104L65.2645 20.8286C64.9955 20.665 64.6728 20.7468 64.5114 21.0195C64.3769 21.265 64.1886 21.565 64.0004 21.8922C62.6018 24.2105 61.2301 23.9377 58.7019 22.7104L55.2592 21.0195C54.9902 20.8831 54.6675 21.0195 54.533 21.2922L52.8654 25.1105C52.7579 25.3832 52.8654 25.7105 53.1344 25.8196C53.8606 26.1741 55.313 26.856 56.6309 27.5105C61.3377 29.8287 65.3452 29.6924 68.4113 24.6468Z"
                            fill="url(#paint3_linear_6402_38719)"
                        />
                    </g>
                    <g clipPath="url(#clip13_6402_38719)">
                        <g clipPath="url(#clip14_6402_38719)">
                            <rect
                                width="86"
                                height="56"
                                transform="translate(213.109 0.867188)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <rect
                                x="220.609"
                                y="25.8672"
                                width="71"
                                height="6"
                                rx="3"
                                fill="#454F59"
                            />
                            <rect
                                width="86"
                                height="56"
                                transform="translate(307.109 0.867188)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <rect
                                x="311.109"
                                y="25.8672"
                                width="64"
                                height="6"
                                rx="3"
                                fill="#454F59"
                            />
                            <g opacity="0.6" clipPath="url(#clip15_6402_38719)">
                                <rect
                                    width="8"
                                    height="20"
                                    transform="translate(381.109 18.8672)"
                                    fill="white"
                                    fillOpacity="0.01"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M381.401 27.1602C381.214 27.3491 381.109 27.604 381.109 27.8697C381.109 28.1354 381.214 28.3903 381.401 28.5792L384.34 31.5442C384.558 31.7592 384.84 31.8662 385.119 31.8662C385.398 31.8662 385.675 31.7592 385.888 31.5442L388.818 28.5892C389.005 28.4002 389.109 28.1453 389.109 27.8797C389.109 27.6141 389.005 27.3592 388.818 27.1702C388.726 27.077 388.617 27.003 388.496 26.9525C388.375 26.902 388.246 26.876 388.115 26.876C387.984 26.876 387.855 26.902 387.734 26.9525C387.613 27.003 387.504 27.077 387.412 27.1702L385.114 29.4872L382.807 27.1602C382.715 27.0674 382.605 26.9937 382.485 26.9434C382.364 26.8931 382.235 26.8672 382.104 26.8672C381.973 26.8672 381.844 26.8931 381.723 26.9434C381.602 26.9937 381.493 27.0674 381.401 27.1602Z"
                                    fill="#8696A7"
                                />
                            </g>
                            <rect
                                width="86"
                                height="56"
                                transform="translate(401.109 0.867188)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <rect
                                x="405.109"
                                y="25.8672"
                                width="64"
                                height="6"
                                rx="3"
                                fill="#454F59"
                            />
                            <g opacity="0.6" clipPath="url(#clip16_6402_38719)">
                                <rect
                                    width="8"
                                    height="20"
                                    transform="translate(475.109 18.8672)"
                                    fill="white"
                                    fillOpacity="0.01"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M475.401 27.1602C475.214 27.3491 475.109 27.604 475.109 27.8697C475.109 28.1354 475.214 28.3903 475.401 28.5792L478.34 31.5442C478.558 31.7592 478.84 31.8662 479.119 31.8662C479.398 31.8662 479.675 31.7592 479.888 31.5442L482.818 28.5892C483.005 28.4002 483.109 28.1453 483.109 27.8797C483.109 27.6141 483.005 27.3592 482.818 27.1702C482.726 27.077 482.617 27.003 482.496 26.9525C482.375 26.902 482.246 26.876 482.115 26.876C481.984 26.876 481.855 26.902 481.734 26.9525C481.613 27.003 481.504 27.077 481.412 27.1702L479.114 29.4872L476.807 27.1602C476.715 27.0674 476.605 26.9937 476.485 26.9434C476.364 26.8931 476.235 26.8672 476.104 26.8672C475.973 26.8672 475.844 26.8931 475.723 26.9434C475.602 26.9937 475.493 27.0674 475.401 27.1602Z"
                                    fill="#8696A7"
                                />
                            </g>
                            <rect
                                width="86"
                                height="56"
                                transform="translate(495.109 0.867188)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <rect
                                x="499.109"
                                y="25.8672"
                                width="64"
                                height="6"
                                rx="3"
                                fill="#454F59"
                            />
                            <g opacity="0.6" clipPath="url(#clip17_6402_38719)">
                                <rect
                                    width="8"
                                    height="20"
                                    transform="translate(569.109 18.8672)"
                                    fill="white"
                                    fillOpacity="0.01"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M569.401 27.1602C569.214 27.3491 569.109 27.604 569.109 27.8697C569.109 28.1354 569.214 28.3903 569.401 28.5792L572.34 31.5442C572.558 31.7592 572.84 31.8662 573.119 31.8662C573.398 31.8662 573.675 31.7592 573.888 31.5442L576.818 28.5892C577.005 28.4002 577.109 28.1453 577.109 27.8797C577.109 27.6141 577.005 27.3592 576.818 27.1702C576.726 27.077 576.617 27.003 576.496 26.9525C576.375 26.902 576.246 26.876 576.115 26.876C575.984 26.876 575.855 26.902 575.734 26.9525C575.613 27.003 575.504 27.077 575.412 27.1702L573.114 29.4872L570.807 27.1602C570.715 27.0674 570.605 26.9937 570.485 26.9434C570.364 26.8931 570.235 26.8672 570.104 26.8672C569.973 26.8672 569.844 26.8931 569.723 26.9434C569.602 26.9937 569.493 27.0674 569.401 27.1602Z"
                                    fill="#8696A7"
                                />
                            </g>
                            <rect
                                width="86"
                                height="56"
                                transform="translate(589.109 0.867188)"
                                fill="white"
                                fillOpacity="0.01"
                            />
                            <rect
                                x="596.609"
                                y="25.8672"
                                width="71"
                                height="6"
                                rx="3"
                                fill="#454F59"
                            />
                        </g>
                        <rect
                            x="691.109"
                            y="12.8672"
                            width="61"
                            height="32"
                            rx="3"
                            fill="#09326C"
                        />
                        <rect
                            x="699.109"
                            y="25.8672"
                            width="44"
                            height="6"
                            rx="3"
                            fill="#454F59"
                        />
                    </g>
                </g>
                <rect
                    width="24"
                    height="24"
                    transform="translate(18.1094 16.8672)"
                    fill="white"
                    fillOpacity="0.01"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.1094 21.8772C22.1094 21.3182 22.5524 20.8672 23.1194 20.8672H25.0994C25.6584 20.8672 26.1094 21.3102 26.1094 21.8772V23.8572C26.1094 24.4162 25.6664 24.8672 25.0994 24.8672H23.1194C22.5604 24.8672 22.1094 24.4242 22.1094 23.8572V21.8772ZM22.1094 27.8772C22.1094 27.3192 22.5524 26.8672 23.1194 26.8672H25.0994C25.6574 26.8672 26.1094 27.3102 26.1094 27.8772V29.8572C26.1094 30.4162 25.6664 30.8672 25.0994 30.8672H23.1194C22.5604 30.8672 22.1094 30.4242 22.1094 29.8572V27.8772ZM28.1094 21.8772C28.1094 21.3192 28.5524 20.8672 29.1194 20.8672H31.0994C31.6574 20.8672 32.1094 21.3102 32.1094 21.8772V23.8572C32.1094 24.4162 31.6664 24.8672 31.0994 24.8672H29.1194C28.5604 24.8672 28.1094 24.4242 28.1094 23.8572V21.8772ZM28.1094 27.8772C28.1094 27.3192 28.5524 26.8672 29.1194 26.8672H31.0994C31.6574 26.8672 32.1094 27.3102 32.1094 27.8772V29.8572C32.1094 30.4152 31.6664 30.8672 31.0994 30.8672H29.1194C28.5614 30.8672 28.1094 30.4242 28.1094 29.8572V27.8772ZM34.1094 21.8772C34.1094 21.3192 34.5524 20.8672 35.1194 20.8672H37.0994C37.6574 20.8672 38.1094 21.3102 38.1094 21.8772V23.8572C38.1094 24.4162 37.6664 24.8672 37.0994 24.8672H35.1194C34.5604 24.8672 34.1094 24.4242 34.1094 23.8572V21.8772ZM34.1094 27.8772C34.1094 27.3192 34.5524 26.8672 35.1194 26.8672H37.0994C37.6574 26.8672 38.1094 27.3102 38.1094 27.8772V29.8572C38.1094 30.4152 37.6664 30.8672 37.0994 30.8672H35.1194C34.5614 30.8672 34.1094 30.4242 34.1094 29.8572V27.8772ZM22.1094 33.8772C22.1094 33.3192 22.5524 32.8672 23.1194 32.8672H25.0994C25.6574 32.8672 26.1094 33.3102 26.1094 33.8772V35.8572C26.1094 36.4162 25.6664 36.8672 25.0994 36.8672H23.1194C22.5604 36.8672 22.1094 36.4242 22.1094 35.8572V33.8772ZM28.1094 33.8772C28.1094 33.3192 28.5524 32.8672 29.1194 32.8672H31.0994C31.6574 32.8672 32.1094 33.3102 32.1094 33.8772V35.8572C32.1094 36.4152 31.6664 36.8672 31.0994 36.8672H29.1194C28.5614 36.8672 28.1094 36.4242 28.1094 35.8572V33.8772ZM34.1094 33.8772C34.1094 33.3192 34.5524 32.8672 35.1194 32.8672H37.0994C37.6574 32.8672 38.1094 33.3102 38.1094 33.8772V35.8572C38.1094 36.4152 37.6664 36.8672 37.0994 36.8672H35.1194C34.5614 36.8672 34.1094 36.4242 34.1094 35.8572V33.8772Z"
                    fill="#8696A7"
                />
                <rect
                    width="1728"
                    height="1117"
                    transform="translate(0.109375 0.867188)"
                    fill="#101214"
                    fillOpacity="0.6"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_6402_38719"
                    x1="620.174"
                    y1="224.462"
                    x2="620.174"
                    y2="210.564"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE5D4" />
                    <stop offset="0.4" stopColor="#FCE1CF" />
                    <stop offset="0.83" stopColor="#F5D6C2" />
                    <stop offset="1" stopColor="#F2D1BB" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_6402_38719"
                    x1="618.878"
                    y1="212.602"
                    x2="622.178"
                    y2="194.597"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.35" stopColor="#91562D" />
                    <stop offset="0.41" stopColor="#775852" />
                    <stop offset="0.51" stopColor="#4D5D8F" />
                    <stop offset="0.6" stopColor="#2B60BF" />
                    <stop offset="0.68" stopColor="#1362E2" />
                    <stop offset="0.75" stopColor="#0564F7" />
                    <stop offset="0.8" stopColor="#0065FF" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_6402_38719"
                    x1="68.1906"
                    y1="38.2432"
                    x2="57.5395"
                    y2="32.2074"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#0052CC" />
                    <stop offset="0.9182" stopColor="#2380FB" />
                    <stop offset="1" stopColor="#2684FF" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_6402_38719"
                    x1="52.965"
                    y1="19.6937"
                    x2="63.6161"
                    y2="25.7294"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#0052CC" />
                    <stop offset="0.9182" stopColor="#2380FB" />
                    <stop offset="1" stopColor="#2684FF" />
                </linearGradient>
                <clipPath id="clip0_6402_38719">
                    <rect
                        width="1728"
                        height="1117"
                        fill="white"
                        transform="translate(0.109375 0.867188)"
                    />
                </clipPath>
                <clipPath id="clip1_6402_38719">
                    <rect
                        width="1488"
                        height="1059"
                        fill="white"
                        transform="translate(240.109 58.8672)"
                    />
                </clipPath>
                <clipPath id="clip2_6402_38719">
                    <rect
                        width="232"
                        height="32"
                        fill="white"
                        transform="translate(1456.11 86.8672)"
                    />
                </clipPath>
                <clipPath id="clip3_6402_38719">
                    <rect
                        width="128"
                        height="32"
                        fill="white"
                        transform="translate(1456.11 86.8672)"
                    />
                </clipPath>
                <clipPath id="clip4_6402_38719">
                    <rect
                        width="192"
                        height="6"
                        fill="white"
                        transform="translate(648.109 206.867)"
                    />
                </clipPath>
                <clipPath id="clip5_6402_38719">
                    <rect
                        width="119"
                        height="14"
                        fill="white"
                        transform="translate(648.109 190.867)"
                    />
                </clipPath>
                <clipPath id="clip6_6402_38719">
                    <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(604.109 190.867)"
                    />
                </clipPath>
                <clipPath id="clip7_6402_38719">
                    <rect
                        width="208"
                        height="374"
                        fill="white"
                        transform="translate(16.1094 138.867)"
                    />
                </clipPath>
                <clipPath id="clip8_6402_38719">
                    <rect
                        width="30"
                        height="30"
                        fill="white"
                        transform="translate(1672.11 13.8672)"
                    />
                </clipPath>
                <clipPath id="clip9_6402_38719">
                    <rect
                        width="314"
                        height="34"
                        fill="white"
                        transform="translate(1339.11 11.8672)"
                    />
                </clipPath>
                <clipPath id="clip10_6402_38719">
                    <rect
                        width="64"
                        height="34"
                        fill="white"
                        transform="translate(1589.11 11.8672)"
                    />
                </clipPath>
                <clipPath id="clip11_6402_38719">
                    <rect
                        width="700"
                        height="56"
                        fill="white"
                        transform="translate(52.1094 0.867188)"
                    />
                </clipPath>
                <clipPath id="clip12_6402_38719">
                    <rect
                        width="137"
                        height="24"
                        fill="white"
                        transform="translate(52.1094 16.8672)"
                    />
                </clipPath>
                <clipPath id="clip13_6402_38719">
                    <rect
                        width="543"
                        height="56"
                        fill="white"
                        transform="translate(209.109 0.867188)"
                    />
                </clipPath>
                <clipPath id="clip14_6402_38719">
                    <rect
                        width="470"
                        height="56"
                        fill="white"
                        transform="translate(209.109 0.867188)"
                    />
                </clipPath>
                <clipPath id="clip15_6402_38719">
                    <rect
                        width="8"
                        height="20"
                        fill="white"
                        transform="translate(381.109 18.8672)"
                    />
                </clipPath>
                <clipPath id="clip16_6402_38719">
                    <rect
                        width="8"
                        height="20"
                        fill="white"
                        transform="translate(475.109 18.8672)"
                    />
                </clipPath>
                <clipPath id="clip17_6402_38719">
                    <rect
                        width="8"
                        height="20"
                        fill="white"
                        transform="translate(569.109 18.8672)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default DarkConfluenceBackground;
